import './slider'

$(document).ready(function () {
  $('.js-cross-line--wrapper').each(function () {
    const $wrapper = $(this)
    const $slider = $wrapper.find('.js-cross-line--slider')
    const $line = $wrapper.find('.js-cross-line')
    const duration = 500
    const classToggle = 'cross-line_hide'
    $slider.on('change', function (e, $slide) {
      $line.addClass(classToggle)
      setTimeout(() => {
        $line.css('background-color', $slide.data('color'))
        $line.removeClass(classToggle)
      }, duration)
    })
    document.documentElement.addEventListener('homePageLoad', () => {
      $line.addClass(classToggle)
      $line.css('background-color', $slider[0].initialSlide.data('color'))
      setTimeout(() => {
        $line.css('transition-duration', duration + 'ms')
        $line.removeClass(classToggle)
      }, 700)
    })
  })
})



// WEBPACK FOOTER //
// ./scripts/cross-line.js